import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'filter-section-title',
  templateUrl: './filter-section-title.component.html',
  styleUrls: ['./filter-section-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterSectionTitleComponent {
  @Input()
  clearable: boolean = false;

  @Output()
  clear = new Subject();
}
